import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy} from '@angular/core';
import {MapViewsComponent} from "../../components/map-views/map-views.component";
import {ImageryProviderService} from "../../services/imageryProvider/imagery-provider.service";
import {NearmapService} from "../../services/nearmap/nearmap.service";
import {MetromapService} from "../../services/metromap/metromap.service";

@Component({
  selector: 'app-map-views',
  templateUrl: './map-views.component.html',
  styleUrls: ['./map-views.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapViewsComponent21 extends MapViewsComponent implements OnDestroy {

  protected tileCb = null;

  constructor(
    protected provider: ImageryProviderService,
    public nearmapService: NearmapService,
    public metromapService: MetromapService,
    protected cdr: ChangeDetectorRef
  ) {
    super(provider, cdr);
  }

  ngOnInit() {
    super.ngOnInit();
    this.nearmapService.loadingDates.subscribe(() => {
      this.cdr.detectChanges();
    });
    let self = this;
    this.tileCb = this.updateComponent.bind(this);
    document.addEventListener('oneTileDownloaded', this.tileCb);
  }

  ngOnDestroy() {
    document.removeEventListener('oneTileDownloaded', this.tileCb);
  }

  updateComponent() {
    this.cdr.detectChanges();
  }

  getWidthByMode(mode){
      if (mode.value.id == '10'){
        return 48;
      }

      if (mode.key.toLowerCase().indexOf('hi-res') >= 0){
        return 25;
      }

      return 18;
  }

  selectViewMode(name, mode) {
    super.selectViewMode(name, mode);
    if (mode.id == 8) {
      this.nearmapService.enable();
    } else {
      this.nearmapService.disable();
    }
    mode.id == this.metromapService.imageryIndex ? this.metromapService.enable() : this.metromapService.disable();
  }
}

